import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import NativeSelect from "../../../../components/select/NativeSelect";
import { getProfileProtection } from "../../../../store/profiles/profiles.selectors";
import { ProtectionEditorDialogContainer } from "./protectionEditorDialog/ProtectionEditorDialogContainer";
import { setBlocked } from "./webFilters.actions";
import {
  useChangeProtectionAction,
  useWebFilterCategories,
  useProtectionLevels,
} from "./hooks";

export interface WebFiltersComponentMobileProps {
  profileId: string;
}

export const WebFiltersComponentMobile = ({
  profileId,
}: WebFiltersComponentMobileProps) => {
  const dispatch = useDispatch();

  const protection = useSelector(getProfileProtection(profileId));
  const protectionLevels = useProtectionLevels(profileId);
  const changeProtection = useChangeProtectionAction(profileId);

  const categories = useWebFilterCategories(profileId);
  const changeStatus = (categoriesNames) =>
    dispatch(setBlocked(categoriesNames, profileId));

  return (
    <Fragment>
      <div className="web-filters__tip">
        <FormattedMessage id={"protection_level_subtitle"} />
      </div>
      <NativeSelect
        id="protection-level-label"
        className="web-filters__protection-select"
        label="protection_level"
        toggleView="input"
        selected={protection}
        options={protectionLevels}
        onChange={changeProtection}
        isSecondary
      />
      <ProtectionEditorDialogContainer
        categories={categories}
        changeStatus={changeStatus}
        profileId={profileId}
      />
    </Fragment>
  );
};
